// SPDX-FileCopyrightText: Copyright 2025 OP Financial Group (https://op.fi). All Rights Reserved.
//
// SPDX-License-Identifier: LicenseRef-OpAllRightsReserved

import React, { useContext } from 'react';
import message from '../messages';
import { ContextWrapper } from '../context/ContextWrapper';

const MainHeader: React.FC = () => {
    const { isAdminFlow } = useContext(ContextWrapper);
    return (
        <h1 className="title-main opux-align-center" data-testid="h1">
            {isAdminFlow ? message('adminFlowAgreementHeading') : message('agreementHeading')}
        </h1>
    );
};

export default MainHeader;
